import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";
import { LSsetItem, isEmpty, localGet, localSet } from "../../lib/common";
import * as adminFunctions from "../../axioscalls/admin.js";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";

toast.configure();

export default function Login(props) {
  const history = useHistory();

  const Wallet_Details = useSelector((state) => state.wallet_detail);

  useEffect(() => {
    if (localGet("adminlogin") == "yes") {
      history.push("/dashboard");
    }
  }, [Wallet_Details.userAccountAddr]);

  const initialValue = {
    email: "",
    password: "",
  };

  const [formValue, setFormValue] = useState(initialValue);
  const [validErrors, setValidErrors] = useState("");
  const [loc, setLoc] = useState("");

  const formvalidation = async (data) => {
    var validationErr = {};
    let emailRegex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([A-Za-zA-Z\-0-9]+\.)+[A-Za-zA-Z]{2,}))$/;

    if (data.email == "") {
      validationErr.email = "Email cannot be empty";
    } else if (data.email != "") {
      if (!emailRegex.test(data.email)) {
        validationErr.email = "Enter valid email";
      }
    }

    if (!data.password) {
      validationErr.password = "password cannot be empty";
    }
    return validationErr;
  };

  const handleSubmit = async () => {
    var data = { email: formValue.email, password: passwordInput };
    var resp = await formvalidation(data);

    if (resp) setValidErrors(resp);
    if (!isEmpty(resp)) {
    } else {
      data.path = "login";
      var Resp = await adminFunctions.loginAdmin(data);
      if (Resp.data) {
        localSet("adminlogin", "yes");
        LSsetItem("adminType", Resp?.Type)
        toast.success(Resp.msg);
        history.push("/dashboard");
      } else toast.error(Resp.msg);
    }
  };

  const handlechange = (e) => {
    const { id, value } = e.target;
    setFormValue({ ...formValue, [id]: value });
  };

  const [passwordType, setPasswordType] = useState("password");
  const [passwordInput, setPasswordInput] = useState("");
  const handlePasswordChange = (evnt) => {
    setPasswordInput(evnt.target.value);
  };
  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  return (
    <div className="login_sec">
      <div className="d-flex align-items-center auth px-0">
        <div className="row w-100 mx-0">
          <div className="col-lg-4 mx-auto">
            <div className="card text-left py-5 px-4 px-sm-5">
              <div className="brand-logo">
                <img src={require("../../assets/images/logo.svg")} alt="logo" />
              </div>
              <h4>Hello! let's get started</h4>
              <h6 className="font-weight-light">Sign in to continue.</h6>
              <Form className="pt-3">
                <Form.Group className="d-flex search-field mb-3">
                  <Form.Control
                    type="email"
                    placeholder="Enter email"
                    size="lg"
                    className="h-auto"
                    id="email"
                    value={formValue.email}
                    onChange={(e) => handlechange(e)}
                  />
                </Form.Group>
                <p className="error_msg">{validErrors.email}</p>
                <div className="input-group passwordinput mb-3">
                  <input
                    type={passwordType}
                    onChange={(e) => handlePasswordChange(e)}
                    value={passwordInput}
                    name="password"
                    class="form-control pw"
                    placeholder="Enter Password"
                  />
                  <div className="input-group-btn ">
                    <button
                      className="btn btn-outline-primary eyebtns"
                      type="button"
                      onClick={() => togglePassword()}
                    >
                      {passwordType === "password" ? (
                        <AiFillEye />
                      ) : (
                        <AiFillEyeInvisible />
                      )}
                    </button>
                  </div>
                </div>
                <p className="error_msg">{validErrors.password}</p>
                <div className="mt-3">
                  <p
                    className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn allbtn allbtns"
                    onClick={() => handleSubmit()}
                  >
                    SIGN IN
                  </p>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
